<div class="popup__buttons">
  <e-buttons [align]="align">
    <ng-content></ng-content>
  </e-buttons>
</div>
